import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import './ProjectContent.css';
import Projects from '../../components/projects/Projects';
import Loader from '../../components/loader/Loader';
import CrmUtils from '../../services/crm-utils/CrmUtils';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import successImg from '../../assets/images/svg/thanks-img.svg';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { useTheme, createTheme } from '@mui/material/styles';
import { he } from 'date-fns/locale'
import { setMoreProjectsRD } from '../../services/store/GenericReducer';
import { Checkbox, ListItemText } from '@mui/material';

function ProjectContent(props) {

	const store = useSelector(state => state.reducer)
	let { id } = useParams()
	const [projectData, setProjectData] = useState(false)
	const [showLoader, setShowLoader] = useState(true)
	const [signupError, setSignupError] = useState(false)
	const [addresses, setAddresses] = useState([])
	const [showCities, setShowCities] = useState(false)
	const [comeTogether, setComeTogether] = useState('startMode')
	const [multipleSignup, setMultipleSignup] = useState(false)
	const [volunteersAmount, setVolunteersAmount] = useState('')
	const [volunteerForm, setVolunteerForm] = useState({})
	const [errorArray, setErrorArray] = useState([])
	const [afterFirstSubmit, setAfterFirstSubmit] = useState(false)
	const dispatch = useDispatch()
	const partnerColor = props.partner.partnerConfig.leadingColor;
	const [moreProjects, setMoreProjects] = useState([])
	const isAdmin = store.userDetails.isManager;
	const [thanksResponse, setThanksResponse] = useState(false)
	const location = useLocation()
	const whatsappLink = `https://api.whatsapp.com/send?text=${window.location.protocol}//${window.location.host}${location.pathname}`
	const encodedSubject = encodeURIComponent("הזדמנות התנדבות מאתר רוח טובה");
	const encodedBody = encodeURIComponent(`היי, רציתי לשתף אותך בהזדמנות התנדבות: ${window.location.href}`);
	const EmailLink = `mailto:?subject=${encodedSubject}&body=${encodedBody}`;

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {PaperProps: {style: {maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250}}}
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [namesList, setNamesList] = useState([]);
	const theme = createTheme({
		direction: 'rtl',
	});

	const handleChange = (event) => {
		setSelectedOptions(event.target.value)
	}

	const getProject = async () => {
		try{
			let res = await CrmUtils.getProjectById(id)
			setProjectData(res.data)
			setShowLoader(false)
		}catch(error){
			console.log(error)
		}
	}

	const getVolunteerForm = async () => {
		try{
			let res = await CrmUtils.getVolunteerForm()
			setVolunteerForm(res.data)
			setNamesList(res.data.volunteersList)
		}catch(error){
			console.log(error)
		}
	}

	/**
	 * display the projects that will be interesting spesific to the client
	 */
	const moreProjectsForClient = async () => {  
		try{
			let projects = store.moreProjects

			//if(store.moreProjects?.length === 0){
				// add try catch must !!!!!
				let res = await CrmUtils.getMoreProjects()
				projects = res.data.projects
			//}	

			let MoreProjectsFinal = removeCurrentProjectFromArray(projects)
			setMoreProjects(MoreProjectsFinal)
			dispatch(setMoreProjectsRD(MoreProjectsFinal))
		} catch(err){
			console.log(err)
		}
	}

	const removeCurrentProjectFromArray = (projects) => {
		return projects.filter(item => item.projectID != id)
	}

	const addressHandle = (adressArray) => {
		let finalArr = [];
		let inner = [];
		for(let i = 0; i < adressArray?.length; i++){
			inner.push(adressArray[i].city.title)
			if( (i + 1) % 6 === 0 && i !== 0){
				finalArr.push(inner)
				inner = []
			}
			if(i === adressArray?.length -1){
				if(inner?.length !== 0){
					finalArr.push(inner)
				}
			}
		}
		setAddresses(finalArr)
	}

	const validateForm = () => {
		let innerErrorArray = []

		// Amount is required and must be greater than zero on every multiple-signup flow
		if(volunteersAmount === '' || +volunteersAmount <= 0){
			innerErrorArray.push('כמות מתנדבים')
		}

		// Manager-only requirements: must pick together/separate and at least one participant
		if(isAdmin){
			if(comeTogether === 'startMode'){
				innerErrorArray.push('הגעה ביחד')
			}
			if(!selectedOptions || selectedOptions.length === 0){
				innerErrorArray.push('בחירת משתתפים')
			}
		}

		setErrorArray(innerErrorArray)
		return innerErrorArray?.length === 0
	}

	const signUpToVolunteer = async (signupJson) => {
		try{
			setShowLoader(true)
			let res = await CrmUtils.signUp(signupJson)
			setShowLoader(false)
			let error_message = res.data.errors && (res.data.errors[0].Value[0] || "לא ניתן להירשם שוב להתנדבות")
			res.data.success ? setThanksResponse(res.data.RegistraionInfo) : setSignupError(error_message)
		}catch(e){console.log(e); setShowLoader(false)}
	}

	const signup = (e) => {
		e.preventDefault();
		setAfterFirstSubmit(true)

		// Participants the manager picked from the list (managers only)
		let selectedToSend = []
		selectedOptions?.length > 0 && selectedOptions.forEach(item => {
			selectedToSend.push({ key: item.id, value: item.lastName + " " + item.firstName })
		})

		// Type 1 — single: manager or regular employee signing up only themselves
		if(!multipleSignup){
			let signupJson = {
				"registrationType": 1,
				"projectIds": [+id],
				"volunteersList": []
			}
			signUpToVolunteer(signupJson)
			return
		}

		// Every multiple flow must pass validation (amount required and > 0)
		if(!validateForm()) return

		// Type 2 — regular employee registering a group (always includes themselves)
		if(!isAdmin){
			let signupJson = {
				"registrationType": 2,
				"projectIds": [+id],
				"volunteersNum": +volunteersAmount,
				"volunteersList": []
			}
			signUpToVolunteer(signupJson)
			return
		}

		// Manager registering multiple people — type depends on group/separate + self inclusion
		const selfSelected = selectedOptions?.some(item => item.id === store.userDetails.id)
		let registrationType
		if(comeTogether){
			// Coming together = a group
			registrationType = selfSelected ? 2 : 4  // 2: incl. manager, 4: excl. manager
		}else{
			// Coming separately = not a group.
			// TEMPORARY: the "individuals + manager" case should be type 5, but there is
			// no registration type for a group of individuals yet, so send 3 for now.
			// Restore `selfSelected ? 5 : 3` once type 5 is supported by the backend.
			registrationType = 3
		}

		let signupJson = {
			"registrationType": registrationType,
			"projectIds": [+id],
			"volunteersList": selectedToSend,
			"volunteersNum": +volunteersAmount
		}
		signUpToVolunteer(signupJson)
	}

	useEffect(() => {
		setShowLoader(true)
		getProject(id)
		getVolunteerForm()
		moreProjectsForClient()
		setMultipleSignup('startMode')
		setComeTogether('startMode')
		setVolunteersAmount('')
		setSelectedOptions([])
		setErrorArray([])
		window.scrollTo(0, 0)
	},[id])

	useEffect(() => {
		if(afterFirstSubmit){
			//validateForm()
		}
	}, [volunteersAmount])

	useEffect(() => {
		projectData.addresses && addressHandle(projectData.addresses)
	}, [projectData])

	useEffect(() => {
		selectedOptions?.length > 0 && console.log(selectedOptions)
	}, [selectedOptions])

  return (
    <>
		<Loader showLoader={showLoader} color={partnerColor}/>
		<div id="main" role="main">
			<section className="record-form__section" id="first-content-section">
				<div className="content-container">
					<div className="record-form__wrapper">
						<div className="project-info">
							<div className="project-info__title">
								<h1>פרטים והרשמה להתנדבות</h1>
								<h2>{projectData.title}</h2>
								<h3>{projectData.parentOrganizationTitle}</h3>
							</div>
							<div className="project-info__image"> 
								<div className="share"> 
									<div>שתפו</div> 
									<a href={whatsappLink} target='blank'>
										<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" fill="#298CCA" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <defs>
                                                <polygon id="path-1" points="0 0 16 0 16 16 0 16"></polygon>
                                            </defs>
                                            <g id="concept_1" stroke="none" strokeWidth="1" fillRule="evenodd">
                                                <g id="פרוייקט-טופס-מקום-עבודה" transform="translate(-961.000000, -1667.000000)">
                                                    <g id="Group-3" transform="translate(961.000000, 1667.000000)">
                                                        <mask id="mask-2" fill="white">
                                                            <use xlinkHref="#path-1"></use>
                                                        </mask>
                                                        <g id="Clip-2"></g>
                                                        <path d="M8.0000692,15.0828986 C6.66677047,15.0828986 5.36752048,14.7104387 4.2432201,14.0056575 C4.1704167,13.9598439 4.08612531,13.9356223 3.99948096,13.9356223 C3.95449788,13.9356223 3.90909956,13.9424043 3.8645317,13.9558301 L1.4231265,14.7073937 C1.60582704,14.0419208 1.92043184,12.9000424 2.11268264,12.230694 C2.14922274,12.1032189 2.12887655,11.9660551 2.05662679,11.8540818 C1.31129162,10.7073591 0.917239769,9.37461397 0.917239769,8.0000692 C0.917239769,4.09456829 4.09456829,0.917239769 8.0000692,0.917239769 C11.9055701,0.917239769 15.0828986,4.09456829 15.0828986,8.0000692 C15.0828986,11.9055701 11.9055701,15.0828986 8.0000692,15.0828986 M8.0000692,0 C3.58881997,0 0,3.58881997 0,8.0000692 C0,9.47938996 0.405955069,10.9214786 1.17468144,12.1750534 C0.993088176,12.8135364 0.705058002,13.8532686 0.339380098,15.1908581 L0.317788216,15.2701667 C0.273773995,15.4316906 0.321248454,15.6042872 0.441941539,15.7202744 C0.528032249,15.8031817 0.641251222,15.8488568 0.760837031,15.8488568 C0.806373758,15.8488568 0.851633665,15.8420748 0.895094248,15.8287874 L3.93719669,14.8928624 C5.16447374,15.6174361 6.56753086,16 8.0000692,16 C12.41118,16 16,12.41118 16,8.0000692 C16,3.58881997 12.41118,0 8.0000692,0 M10.2641718,11.9886158 C10.0083911,11.9886158 9.7261741,11.9657783 9.42541025,11.9205183 C6.40143946,11.4670888 4.4908347,8.45820466 3.90314795,6.93044057 C3.36127475,5.52253912 4.32931081,4.2360228 4.61457279,3.89982612 C4.75145979,3.8790647 4.89194543,3.86646943 4.99173868,3.86646943 C4.99589097,3.86646943 5.00004325,3.86646943 5.00405713,3.86646943 C5.24876513,4.24308169 5.84281871,5.39132691 5.88226542,5.59866435 C5.88101973,5.68835371 5.85499875,5.87645222 5.26302131,6.46884489 C5.17610014,6.55507401 5.12821045,6.67036912 5.12821045,6.79341517 C5.12821045,8.45266828 8.51550619,10.7210616 9.20672324,10.7210616 C9.6431284,10.7210616 10.1898459,10.2518534 10.8324812,9.32589382 C10.9403023,9.38374899 11.1303385,9.50804073 11.3307555,9.63911453 C11.618924,9.82748986 12.0066091,10.0809177 12.4633604,10.3469407 C12.2792758,11.1343524 11.8383031,11.9886158 10.2641718,11.9886158 M13.1998374,9.71081065 C12.6496596,9.40534088 12.1792057,9.09779496 11.8323515,8.8710802 C11.5641139,8.69585377 11.3703406,8.56934749 11.2214119,8.49460635 C11.0692999,8.41861954 10.9159422,8.3801417 10.7660447,8.3801417 C10.4620974,8.3801417 10.2861789,8.53419147 10.2399502,8.58069706 C10.2182199,8.60242736 10.198981,8.62595697 10.1826486,8.65059386 C9.7844445,9.24810768 9.34264137,9.71191792 9.21059871,9.79662454 C9.01281153,9.72520524 8.2636009,9.30402512 7.46663898,8.64021315 C6.69998875,8.00131489 6.18635109,7.37985623 6.07008711,6.95507747 C6.60061073,6.3977024 6.79950519,6.0217822 6.79950519,5.58676113 C6.79950519,5.10135901 5.78274899,3.32431941 5.60932188,3.15089231 C5.47312693,3.01497418 5.25942266,2.94895285 4.95602903,2.94895285 C4.76986825,2.94895285 4.54592168,2.97483542 4.2898641,3.02577012 C4.20128202,3.04376335 4.12045087,3.08694712 4.05595204,3.15103072 C3.97955,3.22743276 2.19628197,5.04765612 3.04694677,7.25971678 C3.95754289,9.62693449 6.29929325,12.379069 9.2892153,12.8275158 C9.62734972,12.8781737 9.95025909,12.9039179 10.2492236,12.9039179 C12.0590663,12.9039179 13.1291101,11.9897231 13.4293203,10.1873546 C13.4617081,9.99634945 13.369389,9.8047907 13.1998374,9.71081065" id="Fill-1" mask="url(#mask-2)"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
									</a>
									<a href={EmailLink} rel="noopener noreferrer">
										<svg width="23" height="16" viewBox="0 0 23 16" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#298CCA">
                                            <defs>
                                                <path id="a" d="M0 0h22.98v15.908H0z"></path>
                                            </defs>
                                            <g fillRule="evenodd">
                                                <mask id="b" fill="#fff">
                                                    <use xlinkHref="#a"></use>
                                                </mask>
                                                <path d="M8.06 8.627l1.154 1.14a3.21 3.21 0 002.276.935c.86 0 1.669-.332 2.276-.935l1.156-1.14 6.423 6.332H1.636L8.06 8.627zm5.03.468a2.257 2.257 0 01-1.6.658 2.259 2.259 0 01-1.6-.659L1.635.949h19.71L13.09 9.095zM7.38 7.958L.958 14.29V1.62L7.38 7.958zm8.22 0l6.424-6.34V14.29L15.6 7.958zM21.132 0H1.849A1.844 1.844 0 000 1.835v12.239c0 1.011.83 1.834 1.85 1.834h19.282c1.02 0 1.849-.823 1.849-1.834V1.834A1.847 1.847 0 0021.13 0z" mask="url(#b)"></path>
                                            </g>
                                        </svg>
									</a>
								</div>
								{(projectData && projectData.images) && 
									<div className="img-holder"> <img src={projectData.images[0].publicUrl} alt="project image"/>
										<h3 className="badge">{projectData.volunteerFields[0].title}</h3>
									</div>}
							</div>
						</div>
						<div className="project-info__description">
							<p className="subtitle">
								{
									projectData.volunteerFields?.map((item, i) => {
										return (<span key={item.volunteerFieldID}>
													{item.title}{(projectData.volunteerFields?.length -1 === i) ? '.' : ', ' }
												</span>)
									})
								}
							</p>
							<p>{projectData.description}</p>
						</div>
						{ projectData &&
						<div className="contacts">
							<h4>חשוב לדעת לפני שנרשמים:</h4>
							<div className="contacts__info">
								<div className="card-info-item card-location with-cities-list"> <svg className="location-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22" fill="#298CCA">
										<path d="M7.997 10.481c-1.773 0-3.215-1.415-3.215-3.153 0-1.74 1.442-3.154 3.215-3.154 1.772 0 3.214 1.415 3.214 3.154 0 1.738-1.442 3.153-3.214 3.153m0-10.46C3.587.02 0 3.54 0 7.866c0 2.695 3.337 8.617 6.136 13.11A2.176 2.176 0 007.996 22c.766 0 1.462-.383 1.861-1.024 2.8-4.493 6.136-10.415 6.136-13.11 0-4.326-3.587-7.845-7.996-7.845" fillRule="evenodd"></path>
									</svg>
									<div className='cities_hover_block' data-default-text="בישובים" onMouseEnter={() => setShowCities(true)} onMouseLeave={() => setShowCities(false)}>{(!projectData.addresses || projectData.addresses?.length < 5) ? projectData.displayCityAndSubdistrict : `ב-${+projectData.addresses?.length} ישובים`}								
										{showCities && <div className="cities-expanded-list multicolumn-4">	 							
																
												{ 
													// When we have more then 9 addresses show addresses ul on hover
													addresses?.map((item, i) => { 
														return(
															<ul key={i}>
																{
																	item?.map((city, ind) => {
																		return(<li key={ind}>{city}</li>)
																	})
																}											
															</ul>
														)	
													})			
												} 																
											
											</div>}
										</div>
									</div>
								<div className="card-info-item working-mode"> <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
										<g fill="#298CCA" fillRule="nonzero">
											<path d="M.527 13h13.795a.51.51 0 0 0 .339-.13C14.793 12.752 17.816 9.98 18 4H3.184C3 9.429.217 11.98.188 12.006a.588.588 0 0 0-.156.624.53.53 0 0 0 .495.37zM17.466 1h-2.673V.5c0-.28-.235-.5-.534-.5-.3 0-.535.22-.535.5V1h-2.707V.5c0-.28-.236-.5-.535-.5-.3 0-.534.22-.534.5V1H7.276V.5c0-.28-.236-.5-.535-.5-.3 0-.534.22-.534.5V1H3.534C3.235 1 3 1.22 3 1.5V3h15V1.5c0-.28-.235-.5-.534-.5z"></path>
											<path d="M15.288 13.691c-.29.222-.655.343-1.03.343H3v1.475c0 .271.239.491.534.491h13.932c.295 0 .534-.22.534-.491V10c-1.03 2.324-2.468 3.503-2.712 3.691z"></path>
										</g>
									</svg>
									<p>{projectData.dateProjectText}</p>
								</div>
								<div className="card-info-item time"> <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18">
										<path d="m16.783 3.972-1.992-1.89a.77.77 0 0 0-1.049 0 .678.678 0 0 0 0 .995l.472.447-.967.918a8.24 8.24 0 0 0-4.425-1.738V1.406h.667c.41 0 .742-.315.742-.703C10.23.315 9.899 0 9.489 0H6.672c-.41 0-.741.315-.741.703 0 .388.332.703.741.703h.667v1.298C3.272 3.053 0 6.292 0 10.336 0 14.572 3.614 18 8.08 18c4.467 0 8.082-3.428 8.082-7.664 0-1.811-.659-3.526-1.867-4.9l.968-.917.471.447a.77.77 0 0 0 1.049 0 .678.678 0 0 0 0-.994zm-4.85 7.564c0 .388-.332.703-.741.703H8.08c-.41 0-.742-.315-.742-.703V6.199c0-.388.332-.703.742-.703s.741.315.741.703v4.634h2.37c.41 0 .741.315.741.703z" fill="#298CCA" fillRule="nonzero"></path>
									</svg>
									<p>{projectData.matchValue} שעות זיכוי</p>
								</div>
							</div>
						</div>
						}
						{!thanksResponse && Array.isArray(volunteerForm?.volunteerFormFields) && volunteerForm.volunteerFormFields.length > 0 && !signupError && <form className={'record-form__form '+ ((multipleSignup === 'startMode') ? "" : ((multipleSignup ? 'record-2__active ' + (errorArray?.length > 0 ? 'error-form ' : '') : '') + (!multipleSignup ? 'record-1__active ' : '')))}>
							<div className="title">
								{volunteerForm.title && <h4>{volunteerForm.title}:</h4>}
								<p className="error-message" role="alert"> הדיווח לא נשלח משום שחלק מהפרטים חסרים:<br/> {errorArray.join(', ')}</p>
							</div>
							{volunteerForm.volunteerFormFields[0]?.title && <p>{volunteerForm.volunteerFormFields[0].title}</p>}
							<div className="btns">
								<input type="radio" name="record" id="record-1" checked={multipleSignup === 'startMode' ? '' : !multipleSignup} onChange={(e) => setMultipleSignup(false)} value="עבורי" />
								<label htmlFor="record-1"> {volunteerForm.volunteerFormFields[0]?.formFieldDetailsObj?.buttons?.[0]?.title} </label>
								<input type="radio" name="record" id="record-2" checked={multipleSignup === 'startMode' ? '' : multipleSignup} onChange={(e) => setMultipleSignup(true)} value="רישום רבים"/>
								<label htmlFor="record-2"> {volunteerForm.volunteerFormFields[0]?.formFieldDetailsObj?.buttons?.[1]?.title} </label>
							</div>
							<div className="record-2">
								{
									isAdmin &&
									<><p>מגיעים ביחד?{/*volunteerForm.volunteerFormFields[2]?.title || ""*/}</p>
									<div className="btns">
										<input type="radio" checked={comeTogether === 'startMode' ? '' : comeTogether} onChange={(e) => setComeTogether(true)} name="coming-together" id="coming-together-yes" value="כן"/>
										<label htmlFor="coming-together-yes"> כן </label>
										<input type="radio" checked={comeTogether === 'startMode' ? '' : !comeTogether} onChange={(e) => setComeTogether(false)} name="coming-together" id="coming-together-no" value="לא, בנפרד"/>
										<label htmlFor="coming-together-no"> לא, בנפרד </label>
									</div></>
								}
								<div className="participant-count">
								<label htmlFor="participant-count">{volunteerForm.volunteerFormFields[2]?.title}</label>
									<input type="number" value={volunteersAmount} onChange={(e) => setVolunteersAmount(+e.target.value)} name="participant-count" id="participant-count"/>
								</div>
								{	(isAdmin && namesList?.length > 0) &&
									<div className="who-add">
										<p>{volunteerForm.volunteerFormFields[4]?.title || "בחירת משתתפים"}</p>
											<Select
											sx={{
												width: '226px',
												margin: '0 auto',
												borderRadius: '0',
												fontSize: '18px',
												fontFamily: "AlmoniDL,Arial,sans-serif",
												"& legend": { display: 'none' },
												"& .MuiSelect-select": { padding: '0 0 3px 0' },
												"& .MuiListItemText-root .MuiTypography-root": { fontSize: '18px' }
											}}
											dir="rtl"
											labelId="multiple-name-label"
											id="multiple-name"
											className="dropdown who-add-dropdown"
											multiple
											value={selectedOptions}
											onChange={handleChange}
											input={<OutlinedInput label="Name" />}
											renderValue={(selected) => `נבחרו ${selected?.length} עובדים`}
											MenuProps={MenuProps}
											>
											{namesList.map((item, index) => {											
												return <MenuItem
													sx={{"& li:not(:last-child)": {borderBottom: "1px solid #000"}}}
													key={index}	
													value={item}										
												>
													<Checkbox checked={selectedOptions.some(option => option.id === item.id)} />
              										<ListItemText primary={
														<div className='d-flex select_menu_item'>
															<div className='d-flex'><div className='spaceL'>{item.firstName}</div><div>{item.lastName}</div></div>
															<div>{item.workerId}</div>
														</div>
													} />							
												</MenuItem>											
											})}
											</Select>
									</div>
								}
							</div> <input type="submit" onClick={(e) => signup(e)} value="הרשמו לפרוייקט" className="btn btn-blue"/>
						</form>}
						{thanksResponse && !signupError && <div className="thanks">
							<div className="thanks__content">
								<h2 role="alert"> {thanksResponse.Title} <br/> <span>{thanksResponse.SubTitle}</span>  </h2>
								<div className="img-holder"> <img src={successImg} width="73" height="132px" alt="thanks image"/> </div> 
								<a href={thanksResponse.ButtonLink} target="_blank" className="btn border-btn">{thanksResponse.ButtonTitle}</a> 
								{/*<!-- img src=thanksResponse.ImageUrl -->*/}
							</div>
						</div>}
						{signupError && !thanksResponse && <div className="error-message reg_error">
							<p>{signupError}</p>
						</div>}
					</div>
				</div>
			</section>
			<section className="card-section cards-slider">
				<div className="content-container">
					<h2 className="title-with-line"><span>אולי יעניין אותך </span></h2>
						<div className="card-wrapper">
							{     		
								moreProjects?.length > 0 ? <Projects partner={props.partner} leadingColor={partnerColor} projects={moreProjects}/> : 
								<Box sx={{ width: '100%' }}>
									<LinearProgress />
								</Box>
							}
						</div>
					<div className="footer-section-link-wrapper"> <a href="index-column-mobile-card" className="footer-section-link"> הצג עוד </a> </div>
				</div>
			</section>
		</div>
	</>
  )
}

export default ProjectContent;